import logo from './logo.svg';
import './App.css';
import vissicomp from './assets/vissicomp.png';
import Home from './Home';
import About from './About';
import Services from './Services';
import Contact from './Contact';
import Header from './Header';
import Footer from './Footer';
import { BrowserRouter,Route,Routes} from 'react-router-dom';


function App() {
  return (
    <>
    <div className="pagecontainer">
    <BrowserRouter>
    <div className="flexrow  bgblack">
          <div className="itembox ">
          <img src={vissicomp} alt="vissicomp" className='img'/>
          </div>
          <div className="itembox">
     <Header/>
     </div>
        </div>
        <div className="flexcolumn">
     <Routes>
       <Route path="/" element={<Home />} />
       <Route path="/about" element={<About />} />
       <Route path="/services" element={<Services />} />
       <Route path="/contact" element={<Contact />} />
     </Routes>
     </div>
     <Footer />
    </BrowserRouter>
   
   
    </div>
    </>
  );
};

export default App;
